import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-create-campaign-success',
  templateUrl: './create-campaign-success.component.html',
  styleUrls: ['./create-campaign-success.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class CreateCampaignSuccessComponent {

}
